import { defineMessages } from 'react-intl';

export const messages: {
	panelSplitterLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	panelSplitterTooltipContent: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	panelSplitterLabel: {
		id: 'navigation.global-side-navigation.panel-splitter.label',
		description:
			'The accessible label for the panel splitter. Visually hidden but read by screen readers.',
		defaultMessage: 'Resize panel',
	},
	panelSplitterTooltipContent: {
		id: 'navigation.global-side-navigation.panel-splitter.tooltip-content',
		description:
			'Text content of the tooltip that appears when hovering over the side navigation resizing element, telling users that double clicking on the element will collapse the side nav',
		defaultMessage: 'Double click to collapse',
	},
});
